;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import type { Promisable } from 'type-fest'

export type RuntimeBindingsProvider = {
  name: string
  getBindings: () => Promisable<Record<string, unknown>>
}

export async function resolveRuntimeBindings({
  providers = [],
}: {
  providers?: RuntimeBindingsProvider[]
}) {
  if (providers.length === 0) {
    return {}
  }

  const resolvedBindings: Record<string, unknown> = {}
  const failedProviderNames: string[] = []

  const results = await Promise.allSettled(
    providers.map((provider) => Promise.resolve(provider.getBindings())),
  )

  providers.forEach((provider, index) => {
    const result = results[index]
    if (!result) {
      return
    }

    if (result.status === 'fulfilled') {
      Object.assign(resolvedBindings, result.value)
      return
    }

    failedProviderNames.push(provider.name)
  })

  if (failedProviderNames.length) {
    resolvedBindings._runtimeBindingsError = `Error fetching runtime bindings from provider(s) ${failedProviderNames.map((name) => `"${name}"`).join(', ')}`
  }

  return resolvedBindings
}
